/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Grid } from 'antd-mobile'
import { formName } from 'utils/constant'
import 'static/css/selectList.css'

const { AFFIRMEMPLOY, SUBSIDY } = formName

/** 点击表单入口后跳转到这个页面 */
function SelectList(props) {

  const { title } = props
  const navigate = useNavigate()
  const [list, setList] = useState([])

  /** 跳转到哪个表单 */
  const getUrl = () => {
    switch (title) {
      case AFFIRMEMPLOY:
        return '/affirmEmploy'
      case SUBSIDY:
        return '/subsidy'
      default:
        return null
    }
  }

  /** 列表上可以选择的选项 */
  const data = useMemo(() => [
    {
      title: title,
      url: getUrl()
    },
    {
      title: '历史记录查询',
      url: '/recordsQuery'
    },
  ], [title])

  /** 社保补贴申请多一个选项 */
  const getList = () => {
    const newList = {
      title: '申请进度查询',
      url: '/progressCheck'
    }
    switch (title) {
      case SUBSIDY:
        setList([...data, newList])
        break
      default:
        setList(data)
    }
  }

  /** 获取列表选项 */
  useEffect(() => {
    getList()
  }, [title]);

  /** 点击进入表单 */
  const handleClick = (url) => {
    navigate(url, { state: { title: title } })
  }

  return (
    <div className="selectEnter">
      <Grid columns={1} gap={30} className='selectItem'>
        {
          list.map((item, index) => (
            <Grid.Item onClick={() => handleClick(item.url)} key={index}>
              {item.title}
            </Grid.Item>
          ))
        }
      </Grid>
    </div>
  )
}

export {
  SelectList
}